import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={{ opacity: reduced ? 1 : 0, y: reduced ? 0 : 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }} {...props}>{children}</motion.div>;
};

export const Cursor = () => {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 180, damping: 28 });
  const sy = useSpring(y, { stiffness: 180, damping: 28 });
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse), (prefers-reduced-motion: reduce)').matches) return;
    const move = e => { x.set(e.clientX - 17); y.set(e.clientY - 17); setActive(Boolean(e.target.closest('a, button'))); };
    window.addEventListener('pointermove', move, { passive: true });
    return () => window.removeEventListener('pointermove', move);
  }, [x, y]);
  return <motion.div aria-hidden="true" className={`cursor-ring ${active ? 'is-active' : ''}`} style={{ x: sx, y: sy }} />;
};